 jQuery(function($) {
	jQuery(document).ready(function() {
		
		// Hide recaptcha badge 
			$('.grecaptcha-badge').css('opacity','0');
		
		// Hamburger Menu
			var $hamburger = $(".hamburger");
			$hamburger.on("click", function(e) {
				$hamburger.toggleClass("is-active");
				// Do something else, like open/close menu
			});
			$('#mobile-menu a').click(function(e) {
				$hamburger.toggleClass("is-active");
				$('#mobile-menu').foundation('toggle'); 
			});
							
		
		// Nav "How it Works"
			$('.menu-item-32').click(function() {
				var url = window.location.hostname;
				console.log(url + "/#how-it-works");
				event.preventDefault();
				window.location.replace("http://" + url + "/#how-it-works");
			});
			
			$('.menu-item-38').click(function(){
				var url = window.location.hostname;
				//console.log(url + "/#how-it-works");
				event.preventDefault();
				window.location.replace("http://" + url + "/#how-it-works");
			});

		// Header Stick
			$(document).on('scroll', function () {
				// if the scroll distance is greater than 100px
				if ($(window).scrollTop() > 0) {
					// console.log('heylldidf');
					$('.head-stick').addClass('pinned');
				} else {
					$('.head-stick').removeClass('pinned');
				}
			});
			
		
		// Home Slider
			$('.slider-folio-main').slick({
				dots: false,
				arrows: false,
				infinite: true,
				// centerMode: true,
				autoplay: false,
				//autoplaySpeed: 3800,
				speed: 300,
				fade: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				pauseOnHover: false,
				pauseOnFocus: false,
				focusOnSelect: true,
				accessibility: false,
				asNavFor: '.slider-folio-nav',
				// variableWidth: true,
				// initialSlide: 1,
			});	
			$('.slider-folio-nav').slick({
				dots: false,
				arrows: false,
				infinite: false,
				// centerMode: true,
				autoplay: false,
				//autoplaySpeed: 3800,
				speed: 300, // ms
				slidesToShow: 2,
				slidesToScroll: 2,
				pauseOnHover: false,
				pauseOnFocus: false,
				focusOnSelect: true,
				accessibility: false,
				asNavFor: '.slider-folio-main',
				// variableWidth: true,
				// initialSlide: 1,
				responsive: [
					{
					breakpoint: 480,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						infinite: false,
						variableWidth: false,
						asNavFor: '.slider-folio-main',
						}
					},
				]
			});
			
		// Home Testimonials Slider
			$('.slide-testimonials').slick({
				dots: true,
				arrows: true,
				infinite: true,
				// centerMode: true,
				autoplay: false,
				//autoplaySpeed: 3800,
				speed: 1000,
				slidesToShow: 3,
				slidesToScroll: 1,
				pauseOnHover: false,
				pauseOnFocus: false,
				focusOnSelect: true,
				accessibility: false,
				//asNavFor: '.slider-folio-nav',
				// variableWidth: true,
				// initialSlide: 1,
				customPaging : function(slider, i) {
					// Nothing
				},
				prevArrow: '<button class="slide-arrow prev-arrow"><i class="fas fa-caret-left"></i></button>',
				nextArrow: '<button class="slide-arrow next-arrow"><i class="fas fa-caret-right"></i></button>',
				responsive: [
					{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
						arrows: true, 
						}
					},
					{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						infinite: true,
						}
					},
				]
			});
			
			
		// Home Tab
			$('#how-it-works .accordion-item').click(function(){
				var i = 0;
				$('.accordion-item').each(function(){
					i++;
					if ($('.accordion-item.item-'+i).hasClass('is-active')) {
						$('.media-support').removeClass('open');
						$('.media-'+i).addClass('open');
						//console.log('hey');
					}
				});
			});
	
	});
});